import {
  Activity,
  Archive,
  Blocks,
  BrainCircuit,
  ChevronsUpDown,
  CircleGauge,
  ClipboardList,
  FileCheck2,
  Gauge,
  HelpCircle,
  LayoutDashboard,
  Menu,
  Network,
  Rocket,
  Search,
  Settings,
  Sparkles,
  Users,
  Workflow,
  X,
} from 'lucide-react'
import { useState } from 'react'
import { NavLink, Outlet, useNavigate } from 'react-router-dom'
import { useDemoStore } from '../store'
import { BrandMark } from './BrandMark'

const primaryNav = [
  ['/app/overview', 'Overview', LayoutDashboard],
  ['/app/tasks', 'Task Inbox', ClipboardList],
  ['/app/brain', 'Business Brain', BrainCircuit],
  ['/app/workflows', 'Workflows', Workflow],
  ['/app/approvals', 'Approvals', FileCheck2],
  ['/app/modules', 'Modules', Blocks],
  ['/app/integrations', 'Integrations', Network],
  ['/app/assets', 'Assets', Archive],
  ['/app/intelligence', 'Intelligence', Sparkles],
  ['/app/venture-studio', 'Venture Studio', Rocket],
  ['/app/usage', 'Usage', Gauge],
  ['/app/team', 'Team', Users],
  ['/app/settings', 'Settings', Settings],
] as const

export function AppShell() {
  const [mobileOpen, setMobileOpen] = useState(false)
  const navigate = useNavigate()
  const { apiMode, runs, approvals } = useDemoStore()
  const pendingApprovals = approvals.filter(item => item.status === 'pending').length
  const live = apiMode === 'live'

  const signOut = () => {
    localStorage.removeItem('dawn-demo-session')
    navigate('/login')
  }

  return (
    <div className="app-shell">
      <aside className={`app-sidebar ${mobileOpen ? 'app-sidebar--open' : ''}`}>
        <div className="app-sidebar__head">
          <BrandMark light compact />
          <button className="icon-button sidebar-close" onClick={() => setMobileOpen(false)} aria-label="Close navigation"><X size={18} /></button>
        </div>
        <button className="workspace-switcher">
          <span className="workspace-switcher__icon">DI</span>
          <span><strong>Deus Intus</strong><small>Tenant 001 · production pilot</small></span>
          <ChevronsUpDown size={16} />
        </button>
        <nav className="app-nav" aria-label="Workspace navigation">
          {primaryNav.map(([to, label, Icon]) => (
            <NavLink key={to} to={to} onClick={() => setMobileOpen(false)}>
              <Icon size={18} /><span>{label}</span>{label === 'Approvals' && pendingApprovals > 0 ? <em>{pendingApprovals}</em> : null}
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-health">
          <div><Activity size={16} /><span>{live ? 'Local control plane' : 'Pilot readiness'}</span><b>{live ? 'Connected' : apiMode === 'connecting' ? 'Connecting' : 'Preview'}</b></div>
          <div className="health-line"><span style={{ width: live ? '82%' : '64%' }} /></div>
          <small>{runs.length} recorded runs · {pendingApprovals} pending approvals</small>
        </div>
        <div className="sidebar-user">
          <span className="user-avatar">AL</span>
          <span><strong>Anthon Linton</strong><small>Founder and tenant owner</small></span>
          <button className="text-button" onClick={signOut}>Sign out</button>
        </div>
      </aside>
      <div className="app-main">
        <header className="app-topbar">
          <button className="icon-button mobile-sidebar-button" onClick={() => setMobileOpen(true)} aria-label="Open navigation"><Menu size={20} /></button>
          <div className="command-search"><Search size={17} /><input aria-label="Search workspace" placeholder="Search DAWN or run a command…" /><kbd>⌘ K</kbd></div>
          <div className="topbar-actions">
            <span className="environment"><CircleGauge size={15} /> {live ? 'Local live · Read only' : 'Preview · Read only'}</span>
            <button className="icon-button" aria-label="Help"><HelpCircle size={19} /></button>
            <button className="button button--gold button--small" onClick={() => navigate('/app/tasks')}><Sparkles size={16} /> New task</button>
          </div>
        </header>
        <section className="app-content"><Outlet /></section>
      </div>
    </div>
  )
}
